module.exports = __webpack_public_path__ + "img/indigo2.492d3096.png";